import styled from 'styled-components'
import { gradient } from 'builder/styles/keyframes'
import Colors from 'builder/styles/colors'
import { Media } from 'builder/styles/media'

export const Container = styled.div`
  display: flex;
  gap: 16px;
  padding: 32px;
  width: 100%;
  height: 100%;

  ${Media.Phone`
    padding: 16px;
    flex-direction: column-reverse;
  `}
`

export const Box = styled.div`
  flex: 1;
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;

  ${Media.Phone`
    align-items: center;
    justify-content: center;
  `}
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const SubHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;

  ${Media.Phone`
    align-items: center;
    justify-content: center;
  `}
`

export const ActionsSkeleton = styled.div`
  margin-top: auto;

  ${Media.Phone`
    width: 100%;
  `}
`

export const Skeleton = styled.div<{ width?: number; height?: number }>`
  border-radius: 6px;
  animation: ${gradient} 1.5s linear infinite;
  background: ${Colors.Neutral10};
  background: linear-gradient(
    to right,
    ${Colors.Neutral10} 5%,
    ${Colors.Neutral15} 15%,
    ${Colors.Neutral10} 25%
  );
  width: ${p => (p.width ? `${p.width}px` : '100%')};
  height: ${p => (p.height ? `${p.height}px` : '100%')};
  background-size: 100vw 100vh;
`
